module.exports = __webpack_public_path__ + "static/media/mirage.135f05fa.png";